import { PageIdentity, PageRecord } from "./recordDefinition.types";

/** The record's name as its page shows it, from the identity's title fields. */
export function recordTitle(
  record: PageRecord,
  identity: PageIdentity | undefined
) {
  return (identity?.titleFields ?? [])
    .map((field) => (typeof record[field] === "string" ? record[field] : ""))
    .join(" ")
    .trim();
}
